import { Controls } from '@glidejs/glide/dist/glide.modular.esm';
class Swiper {
    async initCarSlider() {
        if (document.querySelector('.glide')) {
            const { default: Glide } = await import(/* webpackChunkName: "@glidejs/glide" */ '@glidejs/glide');
            new Glide('.glide', {
                perView: 4,
                breakpoints: {
                    500: {
                        perView: 1
                    },
                    700: {
                        perView: 2
                    },
                    1000: {
                        perView: 3
                    },
                }
            }).mount();
        }
    }
    async initReferenceSlider() {
        if (document.querySelector('.glide-reference')) {
            const { default: Glide } = await import(/* webpackChunkName: "@glidejs/glide" */ '@glidejs/glide');
            new Glide('.glide-reference', {
                perView: 4,
                breakpoints: {
                    500: {
                        perView: 1
                    },
                    700: {
                        perView: 2
                    },
                    1000: {
                        perView: 3
                    },
                }
            }).mount();
        }
    }
    async initDetailGallery() {
        if (document.querySelector('.glide-gallery')) {
            const { default: Glide, } = await import(/* webpackChunkName: "@glidejs/glide" */ '@glidejs/glide');
            new Glide('.glide-gallery', {
                perView: 1,
            }).mount({ Controls });
        }
    }
}
export default new Swiper();
